import { render, staticRenderFns } from "./ModalRecommendation.vue?vue&type=template&id=0c906328&scoped=true&"
import script from "./ModalRecommendation.vue?vue&type=script&lang=js&"
export * from "./ModalRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./ModalRecommendation.vue?vue&type=style&index=0&id=0c906328&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c906328",
  null
  
)

export default component.exports